import * as studentMetricsActions from "../actions/student-metrics.action";
import { Action, createReducer, on } from "@ngrx/store";

import { CourseMetrics } from "cli-types";

export interface StudentMetricsState {
    studentMetrics: CourseMetrics | null;
    loading: boolean;
    loaded: boolean;
}

export const initialState: StudentMetricsState = {
    studentMetrics: null,
    loading: false,
    loaded: false
};
const studentMetricsReducer = createReducer(
    initialState,
    on(
        studentMetricsActions.loadStudentMetrics,
        (state) => {
            return {
                ...state,
                loading: true
            };
        }
    ),
    on(
        studentMetricsActions.loadStudentMetricsSuccess,
        (state, {payload}) => {
            return {
                ...state,
                loading: false,
                loaded: true,
                studentMetrics: payload
            };
        }
    ),
    on(
        studentMetricsActions.loadStudentMetricsFail,
        (state) => {
            return {
                ...state,
                loaded: false,
                loading: false
            };
        }
    ),
)
export function reducer(
    state: StudentMetricsState | undefined,
    action: Action
) {
    return studentMetricsReducer(state, action);
}

export const getStudentMetrics = (state: StudentMetricsState) =>
    state.studentMetrics;
export const getStudentMetricsLoading = (state: StudentMetricsState) =>
    state.loading;
export const getStudentMetricsLoaded = (state: StudentMetricsState) =>
    state.loaded;
